import TextInput from "./text-input.component";
export default TextInput